import { Landmark } from 'lucide-react';

export function BankTransferSection({ property, deposit, appliedCoupon }) {
  const finalDeposit = appliedCoupon ? appliedCoupon.final_deposit : deposit;

  return (
    <div className="border border-[#E7E5E4] dark:border-[#44403C] rounded-xl p-4 mb-3" data-testid="bank-transfer-section">
      <div className="flex items-center gap-2 mb-3">
        <Landmark className="w-4 h-4 text-[#264639]" />
        <p className="text-sm font-semibold text-[#1C1917] dark:text-white">Pago por Transferencia</p>
      </div>
      <p className="text-xs text-[#57534E] dark:text-[#A8A29E] mb-3">
        Realiza tu transferencia y envia el comprobante junto con tus datos y la propiedad que reservas.
      </p>
      <div className="bg-[#F5F4F0] dark:bg-[#292524] rounded-lg p-3 space-y-1.5 text-xs mb-3">
        <p className="font-medium text-[#1C1917] dark:text-white">Datos para transferencia:</p>
        <p className="text-[#57534E] dark:text-[#A8A29E]">Banco: Banco Continental</p>
        <p className="text-[#57534E] dark:text-[#A8A29E]">Titular: Estadia 365</p>
        <p className="text-[#57534E] dark:text-[#A8A29E]">Cuenta: 0123456789</p>
        <p className="text-[#57534E] dark:text-[#A8A29E]">RUC/CI: 1234567-8</p>
      </div>
      <a
        href={`https://wa.me/595982188147?text=${encodeURIComponent(
          `Hola! Realice una transferencia para reservar:\nPropiedad: ${property.title}\nMonto: USD ${finalDeposit}\nAdjunto comprobante.`
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 w-full px-4 py-2.5 bg-[#25D366] text-white rounded-lg hover:bg-[#1DA851] transition-colors text-sm font-medium"
        data-testid="transfer-whatsapp-btn"
      >
        <WhatsAppIcon />
        Enviar comprobante por WhatsApp
      </a>
    </div>
  );
}

function WhatsAppIcon() {
  return (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.75.75 0 00.917.918l4.462-1.494A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.4 0-4.608-.83-6.354-2.217l-.444-.357-4.606 1.528L2.12 16.36l-.366-.45A9.957 9.957 0 012 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"/>
    </svg>
  );
}
